import { 
  Person, 
  Cat, 
  Dog, 
  Horse, 
  Bird, 
  Alien
} from 'phosphor-react';
import React from 'react';
import PropTypes from 'prop-types';

export const avatars = [
  { id: 'person', icon: Person },
  { id: 'cat', icon: Cat },
  { id: 'dog', icon: Dog },
  { id: 'horse', icon: Horse },
  { id: 'bird', icon: Bird },
  { id: 'alien', icon: Alien }
];

export const getAvatarIcon = (type) => {
  const Icon = avatars.find(a => a.id === type)?.icon || Person;
  return <Icon size={32} weight="bold" className="text-gray-300" />;
};

const AvatarSelector = ({ selectedAvatar, onSelect }) => {
  return (
    <div className="space-y-2">
      <h3 className="text-lg font-medium text-gray-300">Twój awatar</h3>
      <div className="flex flex-wrap gap-2 p-2 bg-gray-700/50 rounded-lg border border-gray-600">
        {avatars.map(({ id, icon: Icon }) => (
          <button
            key={id}
            onClick={() => onSelect(id)}
            className={`p-2 rounded-lg transition-all ${
              selectedAvatar === id 
                ? 'bg-blue-600/50 text-blue-300 ring-2 ring-blue-500' 
                : 'text-gray-400 hover:bg-gray-600/50 hover:text-gray-200'
            }`}
          >
            <Icon size={28} weight="bold" />
          </button>
        ))}
      </div>
    </div>
  );
};

AvatarSelector.propTypes = {
  selectedAvatar: PropTypes.string,
  onSelect: PropTypes.func.isRequired
};

export default AvatarSelector;
